export const EditState = Object.freeze({
    Edit: "Edit", //Symbol("Edit"), IE 11 doesn't like Symbol
    Add: "Add", //Symbol("Add"),
    List: "List" //Symbol("List"),
});

export const UserRoles = Object.freeze({
    Administrator: "Administrator",
    SalesRep: "SalesRep",
    GroupStoreBuyer: "GroupStoreBuyer",
    StoreBuyer: "StoreBuyer"
});


// WEBPACK FOOTER //
// ./src/components/shared/enums.js